module.exports = __webpack_public_path__ + "img/avatar.f449dc26.svg";